var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 2C2.24189 2 2 2.2751 2 2.55556V10.3333C2 10.6138 2.24189 10.8889 2.6 10.8889H15.4C15.7581 10.8889 16 10.6138 16 10.3333V2.55556C16 2.2751 15.7581 2 15.4 2H2.6ZM10 12.8889H15.4C16.8092 12.8889 18 11.7711 18 10.3333V2.55556C18 1.11779 16.8092 0 15.4 0H2.6C1.1908 0 0 1.11779 0 2.55556V10.3333C0 11.7711 1.1908 12.8889 2.6 12.8889H8V14H5.8C5.24772 14 4.8 14.4477 4.8 15C4.8 15.5523 5.24772 16 5.8 16H12.2C12.7523 16 13.2 15.5523 13.2 15C13.2 14.4477 12.7523 14 12.2 14H10V12.8889Z",
    fill: "#8B97F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizationIcon);
export default __webpack_public_path__ + "static/media/visualizationIcon.6be8fb21026f841ddd301000a9ed05bd.svg";
export { ForwardRef as ReactComponent };